import React, { Component, useState, useEffect } from "react";
import axios from "axios";
// import logo from "../assets/images/headerbookinglogo.png"
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import PhoneIcon from "@material-ui/icons/Phone";
import { useLocation } from "react-router-dom";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { GoPeople } from "react-icons/go";
import { TbSmartHome } from "react-icons/tb";
import { PiChatsCircle } from "react-icons/pi";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import notificationsArray from "../assets/JSONs/TherapistDashboard/Notifications.json";
import Notification from "./Notification/Notification";
import { THERAPIST_CHATS, THERAPIST_EVENTS, THERAPIST_MY_CLIENTS, THERAPIST_MY_PROFILE, THERAPIST_MY_SESSIONS } from "./Dashboard/TherapistDashboard";
import { useUserInfoSelector } from "store/reducers";

const avatar = {
  female: "https://ucarecdn.com/c22b8f55-8c68-411e-a5c9-8b5b99c08701/femaleEmoji.svg",
  male: "https://ucarecdn.com/52c99efd-cba4-4fe1-93f2-e393088b7a0c/male.svg",
  other: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg",
};

const HeaderDashboardTherapist = ({
  categoryId,
  handleLogout,
  activeComponent,
  showSessions,
  showChats,
  showClients,
  showEvents,
  showProfile,

}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationsPanel, setShowNotificationsPanel] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(
    notificationsArray.length
  );
  const location = useLocation();
  const isActive = (path) => {
    return location.pathname === path;
  };
  const userInfo = useUserInfoSelector();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URI}/api/getNotifications`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setNotifications(response.data.notifications);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };
    fetchNotifications();
  }, []);

  const handleNotificationClick = () => {
  };

  return (
    <div className="headerbookings" style={{ position: "fixed" }}>
      <img
        src="https://ucarecdn.com/4748640f-b537-4b9b-8896-362944eaaae3/headerbookinglogo.png"
        className="image-logo-hb"
      />
      <div className="lists-header-booking">
        <ul>
          <li>
            <a href="/" style={{ textDecoration: "none", color: "#212529" }}>
              Home
            </a>
          </li>
          <li>
            <a
              href="https://www.goodlives.in/how-it-works/"
              style={{ textDecoration: "none", color: "#212529" }}
            >
              How it works?
            </a>
          </li>
          <li>
            <a
              href="/corporates"
              style={{ textDecoration: "none", color: "#212529" }}
            >
              For Corporates
            </a>
          </li>
          <li>
            <a
              href="https://www.goodlives.in/blog/"
              style={{ textDecoration: "none", color: "#212529" }}
            >
              Blogs
            </a>
          </li>
        </ul>
      </div>
      <div className="menu-header-booking">
        <div className="lists-tn notificationsboxcontainer-therapist">
          <NotificationsNoneIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowNotificationsPanel(!showNotificationsPanel);
              setUnreadNotifications(0);
            }}
          />
          <div className="ring-counts">
            <p>{unreadNotifications}</p>
          </div>
          {/* {
            showNotificationsPanel && <Notification
              notifications={notificationsArray}
              onBack={() => {
                setShowNotificationsPanel(!showNotificationsPanel);
                setUnreadNotifications(0);
              }}
            />
          } */}
          {showNotificationsPanel && (
            <div className="notifications-panel">
              {notifications.length > 0 ? (
                <Notification
                  notifications={notifications}
                  onBack={() => {
                    setShowNotificationsPanel(false);
                    setUnreadNotifications(0);
                  }}
                />
              ) : (
                <div className="no-notifications-message">
                  <p>No Notifications</p>
                </div>
              )}
            </div>
          )}
        </div>
        <button onClick={handleLogout} className="therapist-logout-btn">
          <ExitToAppIcon  className="menu-icon" size={25} />
        </button>
        <div className="lists-tn">
          <MenuIcon onClick={() => setMenuOpen(true)} />
        </div>
      </div>
      {menuOpen && (
        <div className="menu-lists-mobile">
          <CloseIcon
            style={{
              position: "absolute",
              top: 15,
              right: 15,
              zIndex: 99,
            }}
            onClick={() => setMenuOpen(false)}
          />
          <div className="left-menustuff">
            <p className="title-lms">
              GoodLives<sup>TM</sup>
            </p>
            <button
              onClick={() => {
                showProfile();
                setMenuOpen(false);
              }}
              className="left-menu-myprofile-btn"
            >
              {userInfo && <img src={userInfo.avatar_url ? userInfo.avatar_url : avatar[userInfo.gender || "female"]} alt="user-avatar" className="avatar" />}
              <div>My Profile</div>
            </button>
            <div className="content-lms">
              <ul>
                <li
                  className={`${activeComponent === THERAPIST_MY_SESSIONS ? "therapistTabActive" : ""}`}
                  onClick={() => { showSessions(); setMenuOpen(false); }}
                >
                  <TbSmartHome className="menu-icon" size={25} />{" "}
                  <p>My Sessions</p>
                </li>
                <li
                  className={`${activeComponent === THERAPIST_CHATS ? "therapistTabActive" : ""}`}
                  onClick={() => { showChats(); setMenuOpen(false); }}
                >
                  <PiChatsCircle className="menu-icon" size={25} /> <p>Chats</p>
                </li>
                <li
                  className={`${activeComponent === THERAPIST_MY_CLIENTS ? "therapistTabActive" : ""}`}
                  onClick={() => { showClients(); setMenuOpen(false); }}
                >
                  <GoPeople className="menu-icon" size={25} /> <p>My Clients</p>
                </li>
                <li
                  className={`${activeComponent === THERAPIST_EVENTS ? "therapistTabActive" : ""}`}
                  onClick={() => { showEvents(); setMenuOpen(false); }}
                >
                  <GoPeople className="menu-icon" size={25} /> <p>Events</p>
                </li>
                <li onClick={handleLogout}>
                  <ExitToAppIcon  className="menu-icon" size={25} /> Sign Out
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      {/* {this.state.showNotificationsPanel && (
          <div
            className="popup-payment-alert-overaly"
            style={{ backgroundColor: "transparent" }}
            onClick={() => {
              this.setState({ showNotificationsPanel: false });
            }}
          ></div>
        )} */}
    </div>
  );
};

export default HeaderDashboardTherapist;
